<template>
  <div id="ready">
    <v-card
      class="mx-auto"
      max-width="600"
      min-width="300"
      color="#f6f6fa"
      min-height="100"
    >
      <p style="color:#FFFFFF;background-color:#5555BB"><b>ゲームスタート</b></p>

      <div v-if="socketConnected">
        <getInviteUrl :roomId="roomId" />
        <gameSetting v-on:show-effect="showEffect"/>
      </div>
      <div v-else>
        <p>ゲームの情報を取得中です．</p>
      </div>

      <p style="padding-top:18px">ホストユーザは全員が揃ったらボタンを押して，<br>ゲームを開始して下さい．</p>
      <div>
        <div class="send-button">
          <sendButton v-if="isHost && users.length>4 && users.length<10 " v-on:pushed="assignRole" label="始める" active="true"/>
          <sendButton v-else label="始める" active="false"/>
        </div>
      </div>

      <!-- <v-btn v-on:click="assignRole" class="send-button white--text" large color="#229954" min-width=80><b>[DEBUG]ゲームを始める</b></v-btn> -->
    </v-card>
  </div>
</template>
<script>
import getInviteUrl from '@/components/roomComponents/GetInviteUrl.vue'
import gameSetting from '@/components/gameComponents/readyComponents/GameSetting.vue'
import sendButton from '@/components/gameUiComponents/SendButton.vue'
export default {
  name: "ready",
  plops: ['joiningRoomId'],
  components: {
    getInviteUrl,
    gameSetting,
    sendButton
  },
  data() {
    return {
      socket: null,
      webSocketUrl: this.$store.state.webSocket.url,
      firstReceive: true,
      buttonMode: this.$route.query.mode,
      userName: this.$route.query.username,
      sent: false,

    };
  },
  computed: {
    users : function() {
      return this.$store.state.userList.users
    },
    userId () {
      return this.$store.getters.userId
    },
    roomId () {
      return this.$store.state.gameInfo.roomId
    },
    isHost () {
      return this.$store.getters.isHost
    },
    socketConnected (){
      return this.$store.state.webSocket.isConnected
    }
  },
  methods: {
    assignRole() {
      // this.sent = true
      this.$emit("send-request", {"action": "assign-role", "roomId": this.roomId, "userId": this.userId, data: {}})
    },
    showEffect: function(id){
      var plot = this.$store.getters.getPlotEffect(id);
      var modalContent = {title: plot.name, text: plot.effect}
      this.$emit('send-modal', modalContent)
    },
  },
  created (){
    var self = this
    const socket = new WebSocket(this.webSocketUrl)
    socket.onopen = function(event){
      console.log(event)
      console.log("Successfully connected to the echo WebSocket Server");
      if (self.buttonMode == 'create'){
        console.log({"action": "create", "data": {"userName": self.userName}})
        socket.send(JSON.stringify({"action": "create", "data": {"userName": self.userName}}))
      }else if(self.buttonMode == 'join'){
        console.log({"action": "join", "data": {"roomId": self.roomId, "userName": self.userName}})
        socket.send(JSON.stringify({"action": "join", "data": {"roomId": self.roomId, "userName": self.userName}}))
      }
    }
    this.socket = socket
    this.$store.commit('setSocket', {'socket': socket})

    socket.onmessage = function(event){
      console.log("Received")
      console.log(event)
      const res = JSON.parse(event.data)
      if (!res.state) {return}
      var loadedUsers = []
      console.log(res)
      console.log(res.state)
      if (res.state != "ready"){
        loadedUsers = convertRoles(res.data.roles)
        for (var i in loadedUsers){
          var item = loadedUsers[i]
          if (item.userId == res.data.firstLeader){
            loadedUsers[i].isLeader = true
          }
          if (self.userId == item.userId){
            self.$store.commit('setMyRole', item.role)
          }
        }
        self.$store.commit('setUsers', loadedUsers)
        self.$store.commit('setMissionRequirement', loadedUsers.length)
        if (self.userId == res.data.firstLeader){
          self.$store.commit('beLeader')
        }else {
          self.$store.commit('beMember')
        }
        self.$emit("show-text", {state: "ready", text: "役割が決定されました．"})
        var nextState = "checking-role"
        if (res.state == "checking-role"){
          nextState = "checkingRole"
        }
        self.$emit("proceed-state", nextState)
      }else {
        console.log("firstReceive: " + self.firstReceive)
        if (self.firstReceive){
          if (res.data.roomId){
            console.log("roomId: " + res.data.roomId)
            self.$store.commit('setRoomId', {'roomId': res.data.roomId})
          }else {
            self.$store.commit('setRoomId', {'roomId': self.roomId})
            console.log("roomId: " + self.roomId)
          }


          // const loadedGame = {
          //     roomId: self.roomId,
          //     masterId: 1111,
          //     masterName: "user1",
          //     leader: 1111,
          //     state: "ready",
          //     result: ["-","-","-","-","-"]
          // };
          // self.$store.commit('setGameInfo', loadedGame)
          var myInfo = {
            name: self.userName,
            id: res.data.userId,
            isHost: false
          }
          if (self.buttonMode == "create") {
            myInfo.isHost = true
            self.$store.commit('setMyInfo', myInfo)
            self.$store.commit('setUsers', [{userId: res.data.userId, userName: self.userName}])
          }else {
            self.$store.commit('setMyInfo', myInfo)
            self.$store.commit('setUsers', res.data.userList)
          }
          self.firstReceive = false
        }else {
          var userName = ""
          if (res.data.userName){
            userName = res.data.userName
            const stateKey = res.state + "-" + userName
            self.$emit("show-text", {state: stateKey, text: (userName + "が入室しました．")})
            loadedUsers = res.data.userList
            self.$store.commit('setUsers', loadedUsers)
          }else {
            userName = self.userName
            const stateKey = res.state + "-" + userName
            self.$emit("show-text", {state: stateKey, text: (userName + "が入室しました．")})
          }
        }
      }
    }
    // テスト用
    // this.isHost = true

  }
}
function convertRoles(roles) {
  var userList = []
  for( var i in roles ){
    var item = roles[i]
    console.log(item)
    userList.push({userName: item.userName, userId: item.userId, role: item.role, isLeader: false})
  }
  return userList
}
</script>
<style>
#ready .send-button {
  padding-bottom: 12px
}
#ready .plot-selecter {
  display: flex;
  align-items: center;
  justify-content: center;

}
#ready .selecter {
  /* justify-content: center; */
  text-align: center;
  /* width: 100%; */
}
#ready .plot-name {
  color: #5555BB;
  cursor:pointer;
}

</style>
